import { render, staticRenderFns } from "./trajectory_total.vue?vue&type=template&id=483ca632&scoped=true&"
import script from "./trajectory_total.vue?vue&type=script&lang=js&"
export * from "./trajectory_total.vue?vue&type=script&lang=js&"
import style0 from "./trajectory_total.vue?vue&type=style&index=0&id=483ca632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483ca632",
  null
  
)

export default component.exports